import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

import React from "react";
import { useTranslation } from "react-i18next";

const PlaceDeleteDialog = ({
  open, selected, handleClose, handleSubmit
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("places.delete")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("places.messages.delete", { count: selected })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("abort")}
        </Button>
        <Button onClick={handleSubmit} color="primary">
          {t("delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlaceDeleteDialog;
